"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _HotelCardTag = _interopRequireDefault(require("../../HotelCardTag/HotelCardTag"));

var _getTags = _interopRequireDefault(require("../../HotelCardTag/utils/getTags"));

var HotelCardTags = function HotelCardTags(_ref) {
  var cancellationPolicy = _ref.cancellationPolicy,
      _ref$extras = _ref.extras,
      extras = _ref$extras === void 0 ? {} : _ref$extras,
      isHotelOnly = _ref.isHotelOnly;

  var getHotelTags = _react["default"].useMemo(function () {
    return (0, _getTags["default"])(extras, isHotelOnly, cancellationPolicy);
  }, [extras, isHotelOnly, cancellationPolicy]);

  if ((0, _isEmpty2["default"])(getHotelTags)) return null;
  return /*#__PURE__*/_react["default"].createElement(StyledFeaturesContainer, null, getHotelTags.map(function (tag, idx) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement(_HotelCardTag["default"], (0, _extends2["default"])({
        key: idx
      }, tag))
    );
  }));
};

var StyledFeaturesContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardTags__StyledFeaturesContainer",
  componentId: "sc-13rzrwn-0"
})(["display:inline-flex;flex-direction:column-reverse;margin-top:auto;> *{align-self:self-start;margin-bottom:4px;}"]);

var _default = HotelCardTags;
exports["default"] = _default;